import { render } from "./CustomerDashboard.vue?vue&type=template&id=9b2c89f4&ts=true"
import script from "./CustomerDashboard.vue?vue&type=script&lang=ts"
export * from "./CustomerDashboard.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\YellowBeardProject\\dobby\\dobbyshopadmin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__